import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import Header from '../../components/Header';
import Appfooter from '../../components/Appfooter';
import Load from '../../components/Load';
import { LISTAR_CIDADES, Cidade, formatCurrency } from '../../services/quadraService';

const MEUS_CREDITOS_CIDADES = gql`
  query MeusCreditosCidades {
    meusCreditosPorLocal {
      localId
      localNome
      cidadeNome
      saldo
    }
  }
`;

const CidadesQuadras: React.FC = () => {
  const { data, loading, error } = useQuery(LISTAR_CIDADES, { fetchPolicy: 'cache-and-network' });
  const { data: creditosData } = useQuery(MEUS_CREDITOS_CIDADES, { fetchPolicy: 'cache-first' });
  const creditos: any[] = creditosData?.meusCreditosPorLocal ?? [];
  const cidades = data?.cidadesComQuadras ?? [];
  const [busca, setBusca] = useState('');

  const navigate = useNavigate();

  const cidadesFiltradas = cidades.filter((c: Cidade) =>
    c.nome.toLowerCase().includes(busca.toLowerCase()) ||
    c.uf.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <Fragment>
      <Header />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left pe-0">
            <div className="row">
              <div className="col-xl-12">

                <div className="card shadow-xss w-100 border-0 p-4 mb-3 d-flex flex-row align-items-center">
                  <div className="flex-grow-1">
                    <h2 className="fw-700 mb-1 font-md text-grey-900 d-flex align-items-center gap-2">
                      <i className="bi bi-geo-alt-fill text-primary"></i> Aluguel de Quadras
                    </h2>
                    <p className="font-xsss text-grey-500 mb-0">Escolha a cidade para ver as quadras disponíveis</p>
                  </div>
                  <div className="ms-3" style={{ minWidth: 220 }}>
                    <div className="position-relative">
                      <i className="feather-search position-absolute text-grey-400" style={{ left: 10, top: '50%', transform: 'translateY(-50%)' }}></i>
                      <input
                        className="form-control rounded-xl font-xsss ps-5"
                        placeholder="Buscar cidade..."
                        value={busca}
                        onChange={e => setBusca(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {loading && <Load />}
                {error && <div className="alert alert-danger">{error.message}</div>}

                {creditos.length > 0 && (
                  <div className="card shadow-xss rounded-xxl border-0 p-3 mb-3">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <i className="bi bi-wallet2 text-success"></i>
                      <span className="fw-700 font-xsss text-grey-900">Créditos disponíveis</span>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      {creditos.map((c: any) => (
                        <div
                          key={c.localId}
                          className="bg-greylight rounded-xl px-3 py-2 d-flex align-items-center gap-2"
                          style={{ cursor: 'pointer' }}
                          onClick={() => navigate(`/quadras/local/${c.localId}`)}
                        >
                          <i className="feather-map-pin text-primary" style={{ fontSize: 12 }}></i>
                          <span className="font-xssss text-grey-700">{c.localNome}{c.cidadeNome ? ` — ${c.cidadeNome}` : ''}</span>
                          <span className="font-xssss fw-700 text-success">{formatCurrency(c.saldo)}</span>
                          <i className="feather-chevron-right text-grey-400" style={{ fontSize: 11 }}></i>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="row ps-2 pe-2">
                  {cidadesFiltradas.map((cidade: Cidade) => (
                    <div key={cidade.id} className="col-lg-4 col-md-6 col-sm-6 mb-3 pe-2 ps-2">
                      <div
                        className="card w-100 shadow-xss rounded-xxl border-0 p-4"
                        style={{ cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                        onClick={() =>
                          navigate(
                            `/quadras/busca?cidadeId=${cidade.id}&cidadeNome=${encodeURIComponent(`${cidade.nome} - ${cidade.uf}`)}`
                          )
                        }
                        onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.13)')}
                        onMouseLeave={e => (e.currentTarget.style.boxShadow = '')}
                      >
                        <div className="d-flex align-items-center">
                          <span
                            className="btn-round-lg bg-primary-gradiant d-flex align-items-center justify-content-center me-3"
                            style={{ minWidth: 48, minHeight: 48 }}
                          >
                            <i className="bi bi-buildings text-white font-md"></i>
                          </span>
                          <div>
                            <h4 className="fw-700 font-xss mb-0 text-grey-900">{cidade.nome} — {cidade.uf}</h4>
                            <span className="font-xssss text-grey-500">
                              {cidade.quantidadeQuadras} quadra{cidade.quantidadeQuadras !== 1 ? 's' : ''} disponível{cidade.quantidadeQuadras !== 1 ? 'is' : ''}
                            </span>
                          </div>
                          <i className="feather-chevron-right ms-auto text-grey-400 font-sm"></i>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {!loading && !error && cidadesFiltradas.length === 0 && (
                  <div className="card shadow-xss w-100 p-5 text-center border-0">
                    <i className="bi bi-geo-alt font-xxl text-grey-300 d-block mb-2"></i>
                    <p className="text-grey-500 font-xss mb-0">
                      {busca ? `Nenhuma cidade encontrada para "${busca}".` : 'Nenhuma cidade com quadras disponíveis no momento.'}
                    </p>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </Fragment>
  );
};

export default CidadesQuadras;
